import { render, staticRenderFns } from "./ActualResultDownload.vue?vue&type=template&id=2c982254&scoped=true&"
import script from "./ActualResultDownload.vue?vue&type=script&lang=ts&"
export * from "./ActualResultDownload.vue?vue&type=script&lang=ts&"
import style0 from "./ActualResultDownload.vue?vue&type=style&index=0&id=2c982254&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c982254",
  null
  
)

export default component.exports